import { ref } from "vue";

const navigationOpen = ref(false);

const toggleNavigationOpen = () => {
  navigationOpen.value = !navigationOpen.value;
};

const setNavigationOpen = (open: boolean) => {
  navigationOpen.value = open;
};

export const useNavigationState = (): {
  navigationOpen: typeof navigationOpen;
  toggleNavigationOpen: typeof toggleNavigationOpen;
  setNavigationOpen: typeof setNavigationOpen;
} => {
  return { navigationOpen, toggleNavigationOpen, setNavigationOpen };
};
